<template>
  <span
    ><span class="fa fa-exclamation text-warning" v-if="customer.vat_validation_status == 'error'"></span
    ><span class="fa fa-check text-success" v-else-if="customer.vat_validation_status == 'ok'"></span
    ><span class="fa fa-question" v-else></span
  ></span>
</template>
<script>
export default {
  props: ['customer'],
  data: function () {
    return {};
  }
};
</script>
